import app from 'flarum/forum/app';

app.initializers.add('aidiscusshub-ai-automator', () => {
    // Initialization code for forum frontend (currently empty since badges are removed)
});